const React = require('react');
const {
  apiV2KycDocumentUpload,
  apiV2KycDocumentRemove,
} = require('../../../../../../api/merchant/kyc');
const InputUpload = require('../../../../../dumb/Upload/D');


module.exports = (props) => {
  return (
    <InputUpload
      apiUpload={apiV2KycDocumentUpload}
      apiRemove={apiV2KycDocumentRemove}
      {...props}
    />
  );
};
